// B3.6 — tour session lifecycle telemetry.

import type { ActivityDockAssistLevel } from "@/lib/activityDock/assistLevel";
import type { PrimaryMode } from "@/components/lead/sections/LeadWorkspaceHeaderAccess";
import type { FireflyIntent } from "@/components/activity/firefly/fireflyIntents";
import type {
  FireflyTourSessionEventDetail,
  FireflyTourSessionPhase,
  FireflyTourTrigger,
} from "./tourTypes";

export const FIREFLY_TOUR_SESSION_EVENT = "bb-firefly-tour-session";

export function buildFireflyTourSessionEventDetail(input: {
  tourId: string;
  phase: FireflyTourSessionPhase;
  trigger: FireflyTourTrigger;
  intent: Extract<FireflyIntent, "teaching" | "discovery" | "guidance">;
  mode: PrimaryMode;
  stepIndex: number;
  stepCount: number;
  assistLevel: ActivityDockAssistLevel;
  nowMs: number;
}): FireflyTourSessionEventDetail {
  return {
    tourId: input.tourId,
    phase: input.phase,
    trigger: input.trigger,
    intent: input.intent,
    mode: input.mode,
    stepIndex: input.stepIndex,
    stepCount: input.stepCount,
    assistLevel: input.assistLevel,
    ts: input.nowMs,
  };
}

export function emitFireflyTourSessionEvent(detail: FireflyTourSessionEventDetail): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent<FireflyTourSessionEventDetail>(FIREFLY_TOUR_SESSION_EVENT, {
      detail,
    }),
  );
}
